 
import { createSlice } from '@reduxjs/toolkit';
import {
  SiteSubjectsListState,
  SiteSubjectsListFetchAction,
  SiteSubjectsListFetchSuccessAction,
  OnNewlyCreatedSubjectAction,
  SiteSubjectsListCreateSubjectAction,
  SiteSubjectsListCreateSubjectSuccessAction,
  SiteSubjectDetailsFetchSuccessAction,
  SiteSubjectDetailsFetchAction,
} from './SiteSubjectsList.types';
import { createSelector, createSliceHook, makeActionCreator } from '../helpers';

const initialState: SiteSubjectsListState = {
  loading: false,
  error: undefined,
  data: undefined,
  newlyCreatedSubjectCode: null,
  subjectDetails: undefined,
  search: '',
};

const { actEmpty, actReject, actReq, actResolve, act } =
  makeActionCreator<SiteSubjectsListState>();

export const SiteSubjectsListSlice = createSlice({
  name: 'SiteSubjectsList',
  initialState,
  reducers: {
    fetchSiteSubjectsList: actReq<SiteSubjectsListFetchAction['payload']>(),
    fetchSiteSubjectsListSuccess:
      actResolve<SiteSubjectsListFetchSuccessAction['payload']>(),
    fetchSiteSubjectsListFailure: actReject(),
    onNewlyCreatedSubject: actResolve<OnNewlyCreatedSubjectAction['payload']>(
      'newlyCreatedSubjectCode'
    ),

    fetchSiteSubjectDetails: actReq<SiteSubjectDetailsFetchAction['payload']>(),
    fetchSiteSubjectDetailsSuccess: act<
      SiteSubjectDetailsFetchSuccessAction['payload']
    >((subjData, state) => ({
      ...state,
      subjectDetails: subjData,
      loading: false,
    })),
    fetchSiteSubjectsDetailsFailure: actReject(),

    clearNewlyCreatedSubject: state => {
      state.newlyCreatedSubjectCode = null;
    },

    setSearchValue: act<string>((searchValue, state) => ({
      ...state,
      search: searchValue,
    })),

    createNewSubject: actReq<SiteSubjectsListCreateSubjectAction['payload']>(),
    createNewSubjectSuccess:
      actEmpty<SiteSubjectsListCreateSubjectSuccessAction['payload']>(),
    createNewSubjectFailure: actReject(),
  },
});

export const {
  fetchSiteSubjectsList,
  fetchSiteSubjectsListSuccess,
  fetchSiteSubjectsListFailure,
  clearNewlyCreatedSubject,
  onNewlyCreatedSubject,
  createNewSubject,
  createNewSubjectFailure,
  createNewSubjectSuccess,
  fetchSiteSubjectDetails,
  fetchSiteSubjectDetailsSuccess,
  fetchSiteSubjectsDetailsFailure,
} = SiteSubjectsListSlice.actions;

export const actions = {
  ...SiteSubjectsListSlice.actions,
};

export const useSiteSubjectsListSlice = createSliceHook(
  SiteSubjectsListSlice.name,
  actions
);

export const selectSiteSubjectsListState = createSelector(SiteSubjectsListSlice.name);
